import AllInPricing from "@shared/modules/financials/components/AllInPricing/AllInPricing.web";
import { getItemPrice } from "@shared/modules/financials/utils/price-utils";
import CurrencyFormat from "@ui-kit/data-display/CurrencyFormat/CurrencyFormat.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import Form from "@ui-kit/form/Form/Form.web";
import { ProductVariantSerializer } from "@app-contexts/public/features/products/data/types/products";
import { enumsTypes } from "@shared/constants";
import { useBasketService } from "@shared/modules/basket/context/BasketServiceContext";
import { useBreakpointValue } from "@shared/hooks/useBreakpointValue";

interface ProductAddonsSelectorCard {
  variant: ProductVariantSerializer;
  currency?: enumsTypes.CurrencyMapIdType;
  amountSelected: number;
  setAmountSelected: ({ amount }: { amount: number }) => void;
}
const ProductAddonsSelectorCard = ({
  variant,
  currency,
  amountSelected,
  setAmountSelected,
}: ProductAddonsSelectorCard) => {
  const { isBasketUpdating, paymentType, purchaseSourcePlatform } =
    useBasketService();

  const handleAmountSelected = (amount: number) => {
    setAmountSelected({ amount });
  };
  const quantityButtonsDataTestId = useBreakpointValue({
    base: `${variant.name}-quantity-select-below`,
    md: `${variant.name}-quantity-select-same-line`,
  });

  return (
    <Flex
      key={variant.id}
      direction={{ base: "column", md: "row" }}
      justify={{ base: "center", md: "space-between" }}
      align="center"
      w="100%"
      bg="bg"
      p="md"
      borderRadius="sm"
    >
      <Box flex={{ base: "1", md: "1" }} w={{ base: "100%", md: "auto" }}>
        <Flex>
          <Flex direction="column" justifyContent="space-between">
            <Text fontWeight="bold" color="font.dark" size="md">
              {variant.name}
            </Text>
            <Flex direction="column" gap="2xs" mt="md">
              <Text fontWeight="bold" color="font.dark" size="sm">
                <CurrencyFormat
                  value={getItemPrice(
                    variant.price || "",
                    true,
                    variant.fees_pricing_info,
                    paymentType,
                    purchaseSourcePlatform
                  )}
                  displayType="text"
                  currency={currency}
                />
                {` ${currency}`}
              </Text>
              <AllInPricing
                hasAllInPricing
                feesPricingInfo={variant?.fees_pricing_info}
                price={variant?.price}
                currency={currency}
              />
            </Flex>
          </Flex>
        </Flex>
      </Box>

      <Box
        flex={{ base: "1", md: "0" }}
        w={{ base: "100%", md: "auto" }}
        mt={{ base: "md", md: "none" }}
      >
        <Flex
          direction="row"
          alignItems="flex-end"
          data-testid={quantityButtonsDataTestId}
        >
          <Form.Incrementer
            size="md"
            min={0}
            max={Math.min(variant.inventory || 0, variant.purchase_limit || 0)}
            value={amountSelected}
            onChange={handleAmountSelected}
            isDisabled={isBasketUpdating}
            isLoading={isBasketUpdating}
            width="100%"
          />
        </Flex>
      </Box>
    </Flex>
  );
};

export default ProductAddonsSelectorCard;
